// extracted by mini-css-extract-plugin
export default {"clipi":"ForgotPasswordPage_clipi__qer5H"};